import { render, staticRenderFns } from "./CbsSso.vue?vue&type=template&id=78107e9f"
import script from "./CbsSso.vue?vue&type=script&lang=js"
export * from "./CbsSso.vue?vue&type=script&lang=js"
import style0 from "./CbsSso.vue?vue&type=style&index=0&id=78107e9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports